import { Link } from "react-router-dom";
import { Card } from "../../components/ui/Card";
import { Kpi } from "../../components/ui/Kpi";
import { CtaButton } from "../../components/ui/Button";
import { ScannerSection } from "./ScannerSection";
import { EvolutionChart } from "./EvolutionChart";
import { useDashboardStats } from "./useDashboardStats";
import { formatNumber } from "../../lib/format";

export function DashboardPage() {
  const stats = useDashboardStats();

  return (
    <>
      <header className="mb-4 flex items-end justify-between">
        <div>
          <div className="font-display text-[26px] font-extrabold tracking-[0.03em]">
            VYNDUX<em className="text-accent-bright not-italic">FIT</em>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-bright/25 bg-accent-soft px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-accent-bright before:h-1.5 before:w-1.5 before:rounded-full before:bg-accent before:shadow-[0_0_8px_#2E6BFF] before:content-['']">
          Fase 1 · Definición
        </span>
      </header>

      <ScannerSection
        chestValue={stats?.currentChest ?? null}
        chestDelta={stats?.chestDelta ?? null}
        waistValue={stats?.currentWaist ?? null}
        waistDelta={stats?.waistDelta ?? null}
      />

      <div className="mb-3 grid grid-cols-3 gap-2.5">
        <Kpi
          label="Peso"
          value={formatNumber(stats?.currentWeight ?? null)}
          delta={
            stats?.weightDelta != null
              ? `${stats.weightDelta <= 0 ? "▼" : "▲"} ${formatNumber(Math.abs(stats.weightDelta))} kg`
              : undefined
          }
        />
        <Kpi label="Sesiones" value={`${stats?.sessionsThisWeek ?? 0}`} delta="esta semana" />
        <Kpi label="Racha" value={`${stats?.streakWeeks ?? 0} sem`} delta="sin fallar" />
      </div>

      <EvolutionChart />

      <Card>
        <p className="mb-1 text-sm text-muted">¿Toca entrenar hoy?</p>
        <Link to="/entreno">
          <CtaButton type="button">Empezar sesión</CtaButton>
        </Link>
      </Card>
    </>
  );
}
